import { useState, useEffect } from "react";
import { API } from "@/lib/api";

// Yüklenemeyen görseller için: direkt → proxy → fallback zinciri
export const SmartImage = ({ src, alt = "", className = "", fallback = null, onFail, ...rest }) => {
  const [stage, setStage] = useState(0);
  useEffect(() => { setStage(0); }, [src]);
  if (!src || stage === 2) return fallback;
  const external = src.startsWith("http") && !src.startsWith(window.location.origin);
  const url = stage === 1 ? `${API}/img-proxy?url=${encodeURIComponent(src)}` : src;
  return (
    <img src={url} alt={alt} className={className} loading="lazy"
      onError={() => {
        if (external && stage === 0) { setStage(1); return; }
        setStage(2);
        onFail?.();
      }} {...rest} />
  );
};
